import { useQuery } from '@tanstack/react-query';
import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'universal-cookie';

import getMe from 'Api/me/getMe';
import { useUserInfo } from 'Store/userInfo';
import { useTranslation } from 'react-i18next';

const ORGANIZATION_LANGUAGE = { 1: 'id', 2: 'en', 3: 'id' };

const useGetMe = ({ isPublic }) => {
  const { i18n } = useTranslation()
  const cookies = new Cookies();
  const today = new Date();
  const { onChangeUserInfo } = useUserInfo();

  const isProduction = process.env.REACT_APP_ENV === 'production';

  return useQuery({
    queryKey: ['me', isPublic],
    queryFn: async () => {
      const { data } = await getMe();

      const { roleId, roleName, name, id, organization, menus, isHost, isBackoffice, isOperator, brand } = data;

      const expirationDate = new Date(today.setMonth(today.getMonth() + 1));

      const userIdentity = { isBackoffice, isHost, isOperator };

      onChangeUserInfo({ roleId, name, roleName, organization, menus, userIdentity, isLoadingUser: false, userBrand: brand });

      cookies.set('username', name, { expires: expirationDate, path: '/' });
      cookies.set('roleId', roleId, { expires: expirationDate, path: '/' });
      cookies.set('roleName', roleName, { expires: expirationDate, path: '/' });
      cookies.set('userId', id, { expires: expirationDate, path: '/' });
      cookies.set('organization', organization, { expires: expirationDate, path: '/' });
      cookies.set('userIdentity', JSON.stringify(userIdentity), { expires: expirationDate, path: '/' });
      cookies.set('userBrand', JSON.stringify(brand), { expires: expirationDate, path: '/' });

      const language = ORGANIZATION_LANGUAGE[Number(organization?.id)];
      if (language && language !== i18n.language) i18n.changeLanguage(language);

      localStorage.setItem('accessPermission', JSON.stringify(menus));

      if (isProduction) datadogRum.setUser({ id, name });

      return { accessPermission: menus, userIdentity } ?? {};
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: !isPublic,
    throwOnError: (error) => error,
  });
};

export default useGetMe;
